import { Button } from '@optimus-web/core';
import { TextKey } from '@mews-commander/enums';
import { WithAccountId, WithName, WithScope } from '@mews-commander/types';
import { LocalizedText, useDialog, useSafeContext } from '@mews/framework';
import { useCommanderThunkDispatch } from '@mews-commander/utils';
import { closeItemAssignmentDialog, moveSelectedItemsToNewBillCloseDialog } from '../../../ducks/itemAssignment';
import { AssociateCurrentOwnerContext } from '../context';
import { BillNameDialog } from '../../../BillNameDialog';
import { useCreateDefaultBillNameValuesFromAccountId } from '../../../BillNameDialog/utils';

interface MoveItemsButtonProps extends WithAccountId, WithScope {
    deleteEmptyBills: () => void;
}

export const MoveItemsButton = ({ accountId, scope, deleteEmptyBills }: MoveItemsButtonProps) => {
    const dispatch = useCommanderThunkDispatch();
    const { associateCurrentOwner } = useSafeContext(AssociateCurrentOwnerContext);
    const [{ onClose, active }, toggleDialog] = useDialog();

    const { defaultValues } = useCreateDefaultBillNameValuesFromAccountId(accountId);

    const handleSubmit = async ({ name }: WithName) => {
        await dispatch(
            moveSelectedItemsToNewBillCloseDialog({
                accountId,
                scope,
                name,
                deleteEmptyBills,
                associateCurrentOwner,
            })
        );
        dispatch(closeItemAssignmentDialog(scope));
    };

    return (
        <>
            <BillNameDialog
                defaultValues={defaultValues}
                submitButtonTextKey={TextKey.CreateAndMove}
                submitAction={handleSubmit}
                titleTextKey={TextKey.CreateNewBill}
                onClose={onClose}
                active={active}
            />
            <Button onClick={toggleDialog} data-move-items-button type="submit">
                <LocalizedText textKey={TextKey.CreateANewBill} />
            </Button>
        </>
    );
};
